<template>
  <nav @keydown.escape="navIsOpen = false" class="bg-gray-800" id="nav">
    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
      <div class="border-b border-gray-700">
        <div class="flex items-center justify-between px-4 sm:px-0">
          <div class="flex items-center">
            <div class="flex-shrink-0">
              <img
                class="h-16 my-2 bg-gray-200 rounded p-2 my-3"
                src="../assets/suma-verde.png"
                alt
              />
            </div>
            <!-- <div class="flex-shrink-0 ml-2 hidden sm:block">
              <img class="h-10 bg-gray-200 rounded p-2" src="../assets/tecnopol.png" alt />
            </div>
            <div class="flex-shrink-0 ml-2 hidden sm:block">
              <img class="h-10 bg-gray-200 rounded p-2" src="../assets/ladrillera.png" alt />
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {};
</script>
